import { render, staticRenderFns } from "./TableDataRow.vue?vue&type=template&id=7c0f84bb&scoped=true"
import script from "./TableDataRow.vue?vue&type=script&lang=js"
export * from "./TableDataRow.vue?vue&type=script&lang=js"
import style0 from "./TableDataRow.vue?vue&type=style&index=0&id=7c0f84bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0f84bb",
  null
  
)

export default component.exports